import { publicProfileConstants } from "../../_constants";

const initialState = {};

export const get_user_public_profile_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case publicProfileConstants.GET_USER_PUBLIC_PROFILE_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case publicProfileConstants.GET_USER_PUBLIC_PROFILE_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userPublicProfileData: action.payload,
      };
    case publicProfileConstants.GET_USER_PUBLIC_PROFILE_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_all_public_event_links_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case publicProfileConstants.GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case publicProfileConstants.GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        publicEventLinksData: action.payload,
      };
    case publicProfileConstants.GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_all_candidate_public_assessment_kits_lists_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        publicAssessmentKitsListsData: action.payload,
      };
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_all_candidate_public_assessment_kits_videos_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        publicAssessmentKitsVideosData: action.payload,
      };
    case publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_mentor_public_profile_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        mentorPublicProfileData: action.payload,
      };
    case publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
